import { config } from "../../config";
import { getKismetClientId } from "../utils/getKismetClientId";
import { updateProfile } from "../../components/Forms/networking/otpService";

/**
 * Updates an existing user marketing profile with the form data
 * @param profileId The ID of the user marketing profile to update
 * @param formData The form data with updated information
 * @returns Promise with the API response
 */
export const updateUserMarketingProfile = async (
  profileId: string | null,
  formData: any
): Promise<any> => {
  try {
    if (!profileId) {
      throw new Error("No User Marketing Profile ID available");
    }

    console.log("Updating existing user marketing profile:", profileId);

    const response = await fetch(
      `${config.backend.base_url}/UserMarketingProfile/UpdateUserMarketingProfile`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: profileId,
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phoneNumber: formData.phone,
          emailMarketingOptIn: formData.marketingConsent,
          smsMarketingOptIn: formData.marketingConsent,
          hotelId: getKismetClientId(),
        }),
      }
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();

    // Log the full response for debugging
    console.log("🔍 API Response (Profile Update):", data);

    // Check for error response
    if (data.type === "ERROR") {
      console.warn(
        "⚠️ API returned an error during profile update:",
        data.error
      );
      return data;
    }

    // Handle success response
    if (data.success) {
      console.log("✅ Marketing Profile Updated:", {
        id: data.success.id,
        firstName: data.success.firstName,
        lastName: data.success.lastName,
        updatedAt: data.success.updatedAt,
        hasEmail: !!data.success.email,
        hasPhone: !!data.success.phoneNumber,
      });

      // Update the session storage
      try {
        updateProfile({
          UMP_ID: data.success.id,
          email: data.success.email || null,
          phoneNumber: data.success.phoneNumber || null,
          firstName: data.success.firstName,
          lastName: data.success.lastName,
          lastUpdated: new Date().toISOString(),
        });

        console.log("✅ Updated profile data in session storage:", {
          id: data.success.id,
          hasEmail: !!data.success.email,
          hasPhone: !!data.success.phoneNumber,
        });
      } catch (storageError) {
        console.error(
          "Failed to update profile data in storage:",
          storageError
        );
        // Continue execution even if storage fails
      }
    }

    return data;
  } catch (error) {
    console.error("Error updating marketing profile:", error);
    throw error;
  }
};
